/*
 * ap-komplett-reifen.js — <ap-komplett-reifen>: die Reifen-Auswahl mit Produktkarten unter
 * „Reifen für diese Felge" (sections/wheel-tyre-link.liquid). Phase B, Paket „komplett",
 * 29.09.2026. Betreiber 26.09.: unter „Komplett machen" echte Reifen-Produkte statt nur Links.
 *
 * DATEN: App-Proxy GET /apps/tyre-search/felgen-set?pid=<product.id>&vid=<variant.id>
 * (tyre-trader-eu app/routes/proxy.felgen-set._index.tsx, Vertrag v1 in
 * app/lib/catalog/felgen-set.ts FelgenSetAntwort). Gelesen wird nur:
 *   felge.zoll, felge.j, felge.winterfest, hinweise[].code
 *   reifen.status == "ok", reifen.groessen[]: breite, querschnitt, zoll, anzahl{alle,sommer,
 *     winter,ganzjahr}, abPreis{neu, dot, dotJahr}, ziel{url,count}|null
 *   reifen.andere[] mit grund "ausserhalb-j" (Groessen ausserhalb der J-Spanne — nur als Hinweis,
 *     nie „nicht montierbar"; "ohne-norm"/"nur-b-kontur" sind KEINE Aussage und bleiben weg)
 * Alles andere (Ring, Befestigung) gehoert dem Zubehoerblock „Das brauchen Sie zur Felge".
 *
 * ZEIGEN ODER NICHTS: die Huelle steht serverseitig `hidden` da und wird NUR sichtbar, wenn die
 * Antwort Vertrag v1, status "ok", reifen.status "ok" und mindestens eine Groesse mit Anzahl > 0
 * traegt. 404 (Route noch nicht ausgerollt — bis zum Promote der Normalfall), Zeitlimit,
 * Netzfehler, "retry", "unbekannt", "keine-felge", "keine-pkw-felge", "ohne-mass",
 * "keine-groesse", kaputtes JSON: die Huelle bleibt versteckt, kein Fehlertext, kein leerer
 * Kasten. 404 legt die Abfrage fuer die Sitzung still (wie ap-size-target.js).
 *
 * WANN: erst nach `load` im Leerlauf, und erst wenn der Abschnitt naeher als 1.500 px an den
 * sichtbaren Bereich kommt (IntersectionObserver auf den sichtbaren Wirt .ap-wheel-link — die
 * versteckte Huelle selbst schneidet nie). So zahlt nur, wer in die Naehe scrollt, und der
 * Block erscheint, BEVOR er ins Bild kommt (kein Sprung im Sichtbereich). Die Antwort merkt
 * sich sessionStorage 30 Minuten (nicht bei "retry"). Fragt der Zubehoerblock derselben Seite
 * die App schon selbst (ap-felgen-set.js), teilen beide EINEN Abruf (geteilterAbruf unten).
 *
 * KARTEN: echte card-product-Karten per Section Rendering API von
 * sections/ap-komplett-reifen.liquid, aufgerufen auf dem ZIEL der Groesse:
 *   Saison „Alle": groessen[].ziel.url (App: size-target scope „felge", alle Saisons)
 *   Sommer/Winter/Ganzjahr: window.apSizeTarget({kind:'tyre', scope:'felge', w, a, r, season})
 * Das Theme baut KEINEN Handle und keinen Tag (Vertrag ap-size-target.js); jede Adresse muss
 * ein Kollektionspfad des Ladens sein (ZIEL_RE — dieselbe Form wie ERLAUBTE_ADRESSE der App).
 * Kein Ziel: keine Karten, kein Link — Groesse, Anzahl und Ab-Preise bleiben stehen. Der
 * Schnellkauf der Karten („4× In den Korb") ist der von card-product: product-form.js ->
 * window.ApCartAdd.kauf, der gemeinsame Warenkorb-Pfad — hier gibt es keinen eigenen Abruf.
 *
 * ALTERSREGEL (Betreiber 26./27.09.2026, App reifenalter.ts): DOT-Jahr IMMER sichtbar;
 * Kalenderjahres-Differenz <= 1 „Fabrikneu", 2–5 „Neuware", >= 6 „DOT-Ware"; ein unlesbares
 * Jahr (auch eines in der Zukunft) heisst „DOT-Ware ohne Jahresangabe". abPreis.neu ist Ware
 * OHNE DOT-Angabe und heisst immer „Fabrikneu (laut Lieferant max. 2 Jahre)" — nie ein nacktes
 * „fabrikneu". Keine Ersparnis, kein Streichpreis: zwei Ab-Preise nebeneinander, jeder mit
 * seiner Grundlage.
 *
 * KARTENZIEL DER PKW-LINKKARTE (der fruehere offene Punkt im Kopf von wheel-tyre-link): hat
 * der Proxy mit reifen.status "ok" geantwortet, ist die Umleitung derselben App-Auslieferung
 * live und kennt fuer diese Maulweite eine Normgroesse — dann zeigt die Karte
 * [data-ap-kr-link] auf /apps/tyre-search/felgen-set/reifen?d=&j=&klasse=pkw (302 auf das
 * PKW+SUV-Ziel des Zolls) mit der Beschriftung aus data-ap-kr-link-label. Im MUSTER-MODUS
 * NICHT (die Route ist dort nicht live, der Link liefe ins Leere).
 *
 * MUSTER-MODUS (nur Vorschau, settings.ap_muster_komplett): statt des Proxys gilt die
 * Beispielantwort aus <script data-ap-kr-muster> (snippets/ap-komplett-muster.liquid) — sofort,
 * ohne Abruf; die Saison-Ziele stehen dort unter `_muster.saisonZiele` (live liefert sie
 * size-target). Die Karten kommen auch im Muster ueber die Section Rendering API von echten
 * Produkten.
 *
 * Keine Abhaengigkeit, Vanilla, laeuft auch mehrfach eingebunden genau einmal.
 */
(function () {
  'use strict';

  if (!window.customElements || window.customElements.get('ap-komplett-reifen')) return;

  var ENDPOINT = '/apps/tyre-search/felgen-set';
  var UMLEITUNG = '/apps/tyre-search/felgen-set/reifen';
  var KARTEN_SECTION = 'ap-komplett-reifen';
  var TIMEOUT_MS = 4000;
  var KARTEN_TIMEOUT_MS = 8000;
  var CACHE_PREFIX = 'ap_felgen_set:v1:';
  var CACHE_MS = 30 * 60 * 1000;
  var AUS_KEY = 'ap_felgen_set:aus';
  var VORLAUF = '1500px 0px';
  // Nur Kollektionspfade des Ladens — dieselbe Form wie ERLAUBTE_ADRESSE in felgen-set.ts.
  var ZIEL_RE = /^\/collections\/[a-z0-9][a-z0-9-]*(?:\/[a-z0-9][a-z0-9-]*)?(?:\?[A-Za-z0-9._~%=&+-]+)?$/;
  var SAISONS = ['alle', 'sommer', 'winter', 'ganzjahr'];
  // Vertragswerte von size-target `season` (= Metafeld tyre.season).
  var SAISON_WERT = { sommer: 'Sommer', winter: 'Winter', ganzjahr: 'Ganzjahr' };
  var ALLE_TEXT = { alle: 'alle', sommer: 'alleSommer', winter: 'alleWinter', ganzjahr: 'alleGanzjahr' };
  var KARTEN_TEXT = { alle: 'kartenAlle', sommer: 'kartenSommer', winter: 'kartenWinter', ganzjahr: 'kartenGanzjahr' };
  var SORTS = { 'price-ascending': true, 'best-selling': true };
  var DOT_MIN_JAHR = 1980;

  /* ---------------------------------------------------------------- Helfer */

  function storageGet(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (e) {
      /* Speicher aus — dann ohne Cache */
    }
  }

  function zahl(v) {
    return typeof v === 'number' && isFinite(v) ? v : null;
  }

  function ganzeZahl(v) {
    return typeof v === 'number' && isFinite(v) && Math.floor(v) === v ? v : null;
  }

  function zielUrl(ziel) {
    if (!ziel || typeof ziel !== 'object' || typeof ziel.url !== 'string') return null;
    if (typeof ziel.count === 'number' && !(ziel.count > 0)) return null;
    return ZIEL_RE.test(ziel.url) ? ziel.url : null;
  }

  function sichereUrl(url) {
    return typeof url === 'string' && ZIEL_RE.test(url) ? url : null;
  }

  /** Vierstelliges DOT-Jahr der App — oder null (unlesbar, vor 1980, in der Zukunft). */
  function jahrAus(roh, heute) {
    var s = String(roh == null ? '' : roh).trim();
    if (!/^\d{4}$/.test(s)) return null;
    var n = Number(s);
    return n >= DOT_MIN_JAHR && n <= heute ? n : null;
  }

  /** Altersstufe nach der Kalenderjahr-Regel (Jahr schon geprueft). */
  function altersstufe(jahr, heute) {
    if (jahr == null) return 'dotware';
    var diff = heute - jahr;
    if (diff <= 1) return 'fabrikneu';
    if (diff <= 5) return 'neuware';
    return 'dotware';
  }

  /** Die Beschriftung des DOT-Ab-Preises: „DOT 2023 · Neuware" bzw. „DOT-Ware ohne Jahresangabe". */
  function dotBeschriftung(jahr, heute, t) {
    if (jahr == null) return t.dotOhneJahr || '';
    var stufe = altersstufe(jahr, heute);
    var text = fuelle(t.dotJahr, { jahr: jahr });
    return t[stufe] ? text + ' · ' + t[stufe] : text;
  }

  /**
   * Link „Alle …" (Phase D, Q-01): nie ein <a> ohne href im Dokument. Ein solches <a> zaehlt bei
   * Lighthouse als nicht crawlbarer Link, sobald ein fremdes Skript (PayPal pa.js,
   * Analytics.trackClicks) einen Klick-Hoerer anhaengt (pdp-felge SEO 92). Der Server gibt einen
   * <span> aus; mit sicherem Ziel wird daraus ein <a>, ohne Ziel wieder ein <span>. Attribute
   * (ausser href) und Kinder wandern mit, die Kinder bleiben dieselben Knoten.
   */
  function alsTag(el, tag) {
    if (!el || !el.parentNode || el.tagName.toLowerCase() === tag) return el;
    var neu = document.createElement(tag);
    for (var i = 0; i < el.attributes.length; i++) {
      var a = el.attributes[i];
      if (a.name !== 'href') neu.setAttribute(a.name, a.value);
    }
    while (el.firstChild) neu.appendChild(el.firstChild);
    el.parentNode.replaceChild(neu, el);
    return neu;
  }

  function fuelle(vorlage, werte) {
    var out = String(vorlage || '');
    Object.keys(werte).forEach(function (k) {
      out = out.split('[' + k + ']').join(String(werte[k]));
    });
    return out;
  }

  /** Dezimalzahl in der Schreibweise der Seite (de: Komma). */
  function dezimal(n, sprache) {
    var s = String(n);
    return sprache === 'de' ? s.replace('.', ',') : s;
  }

  // Geldbetrag in Cent -> Schreibweise DIESES Shops (window.apMoneyFormat aus
  // layout/theme.liquid, dieselben Platzhalter wie automotive.js formatMoney).
  function geldBetrag(cents, art) {
    var wert = (Number(cents) || 0) / 100;
    function trenne(stellen, tausend, dezimalzeichen) {
      var teile = Math.abs(wert).toFixed(stellen).split('.');
      var ganz = teile[0].replace(/\B(?=(\d{3})+(?!\d))/g, tausend);
      return (wert < 0 ? '-' : '') + (teile[1] ? ganz + dezimalzeichen + teile[1] : ganz);
    }
    switch (art) {
      case 'amount':
        return trenne(2, ',', '.');
      case 'amount_no_decimals':
        return trenne(0, ',', '.');
      case 'amount_with_comma_separator':
        return trenne(2, '.', ',');
      case 'amount_no_decimals_with_comma_separator':
        return trenne(0, '.', ',');
      case 'amount_with_space_separator':
        return trenne(2, ' ', ',');
      case 'amount_no_decimals_with_space_separator':
        return trenne(0, ' ', ',');
      case 'amount_with_apostrophe_separator':
        return trenne(2, "'", '.');
      case 'amount_with_period_and_space_separator':
        return trenne(2, ' ', '.');
      default:
        return null;
    }
  }

  function nurText(html) {
    if (!/[<&]/.test(html)) return html;
    try {
      return new DOMParser().parseFromString(html, 'text/html').body.textContent || '';
    } catch (e) {
      return html.replace(/<[^>]*>/g, '');
    }
  }

  /** Euro (Zahl, inkl. MwSt.) -> Text im Geldformat des Shops. */
  function geld(euro) {
    var cents = Math.round(euro * 100);
    var format = typeof window.apMoneyFormat === 'string' ? window.apMoneyFormat : '';
    var treffer = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (treffer) {
      var betrag = geldBetrag(cents, treffer[1]);
      if (betrag !== null) return nurText(format.replace(/\{\{\s*(\w+)\s*\}\}/, betrag));
    }
    var locale = document.documentElement.lang || 'de-DE';
    return (cents / 100).toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  /* ------------------------------------------------------ Vertrag v1 lesen */

  /**
   * Die Antwort auf das, was dieser Block braucht — oder null (dann bleibt er versteckt).
   * Streng: jede Groesse braucht ganze Breite/Querschnitt, einen Zoll und eine Anzahl > 0.
   */
  function leseAntwort(a, heute) {
    if (!a || typeof a !== 'object' || a.v !== 1 || a.status !== 'ok') return null;
    var felge = a.felge && typeof a.felge === 'object' ? a.felge : null;
    var reifen = a.reifen && typeof a.reifen === 'object' ? a.reifen : null;
    if (!felge || !reifen || reifen.status !== 'ok' || !Array.isArray(reifen.groessen)) return null;
    var jahrHeute = typeof heute === 'number' ? heute : new Date().getFullYear();
    var zoll = zahl(felge.zoll);
    var j = zahl(felge.j);
    var groessen = [];
    reifen.groessen.forEach(function (g) {
      if (!g || typeof g !== 'object') return;
      var breite = ganzeZahl(g.breite);
      var qs = ganzeZahl(g.querschnitt);
      var r = zahl(g.zoll);
      var an = g.anzahl && typeof g.anzahl === 'object' ? g.anzahl : {};
      var anzahl = {};
      SAISONS.forEach(function (s) {
        var n = ganzeZahl(an[s]);
        anzahl[s] = n != null && n > 0 ? n : 0;
      });
      if (breite == null || qs == null || r == null || !(anzahl.alle > 0)) return;
      var ab = g.abPreis && typeof g.abPreis === 'object' ? g.abPreis : {};
      var neu = zahl(ab.neu);
      var dot = zahl(ab.dot);
      groessen.push({
        breite: breite,
        querschnitt: qs,
        zoll: r,
        key: breite + '/' + qs,
        anzahl: anzahl,
        neu: neu != null && neu > 0 ? neu : null,
        dot: dot != null && dot > 0 ? dot : null,
        dotJahr: jahrAus(ab.dotJahr, jahrHeute),
        ziel: zielUrl(g.ziel),
      });
    });
    if (!groessen.length) return null;
    var andere = [];
    (Array.isArray(reifen.andere) ? reifen.andere : []).forEach(function (x) {
      if (!x || typeof x !== 'object' || x.grund !== 'ausserhalb-j') return;
      var b = ganzeZahl(x.breite);
      var q = ganzeZahl(x.querschnitt);
      if (b == null || q == null || !(ganzeZahl(x.anzahl) > 0)) return;
      andere.push(b + '/' + q);
    });
    var hinweise = Array.isArray(a.hinweise) ? a.hinweise : [];
    var nichtWinterfest =
      felge.winterfest === false ||
      hinweise.some(function (h) {
        return h && h.code === 'nicht-winterfest';
      });
    return { zoll: zoll, j: j, groessen: groessen, andere: andere, nichtWinterfest: nichtWinterfest };
  }

  /* ------------------------------------------------------------- Abrufe */

  function mitFrist(ms, arbeit) {
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer;
    var frist = new Promise(function (resolve) {
      timer = setTimeout(function () {
        if (controller) {
          try {
            controller.abort();
          } catch (e) {
            /* schon beendet */
          }
        }
        resolve({ zeitlimit: true });
      }, ms);
    });
    var lauf;
    try {
      lauf = Promise.resolve(arbeit(controller ? controller.signal : undefined));
    } catch (e) {
      lauf = Promise.resolve({ fehler: true });
    }
    return Promise.race([lauf, frist]).then(
      function (x) {
        clearTimeout(timer);
        return x;
      },
      function () {
        clearTimeout(timer);
        return { fehler: true };
      },
    );
  }

  function gemerkt(key) {
    var roh = storageGet(key);
    if (!roh) return undefined;
    try {
      var x = JSON.parse(roh);
      if (x && typeof x === 'object' && typeof x.t === 'number' && Date.now() - x.t < CACHE_MS && x.a) return x.a;
    } catch (e) {
      /* fremd beschrieben — neu fragen */
    }
    return undefined;
  }

  /**
   * EIN felgen-set-Abruf je Seite (Integration Phase B, 29.09.2026): fragt der Zubehoerblock
   * „Das brauchen Sie zur Felge" (assets/ap-felgen-set.js, <ap-felgen-set data-app="1">, kein
   * Muster) DIESELBE Felge schon selbst bei der App, gilt seine Zusage
   * window.apFelgenSet.antwort(endpoint, pid, vid) — sie liefert nur gueltige Antworten (v1,
   * status ok) oder null und merkt sich keine Absage. Sonst null: dann der eigene Abruf unten
   * (mit 404-Stilllegung). Nie reject.
   */
  function geteilterAbruf(pid, vid) {
    var api = window.apFelgenSet;
    if (!api || typeof api.antwort !== 'function') return null;
    var host = document.querySelector('ap-felgen-set[data-app="1"]:not([data-muster])');
    if (!host || host.getAttribute('data-pid') !== pid || host.getAttribute('data-vid') !== vid) return null;
    try {
      return Promise.resolve(api.antwort(host.getAttribute('data-endpoint') || ENDPOINT, pid, vid)).then(
        function (data) {
          return data;
        },
        function () {
          return null;
        },
      );
    } catch (e) {
      return null;
    }
  }

  /** felgen-set fuer diese Felge: Promise<Antwort-Objekt|null>. Nie reject. */
  function ladeFelgenSet(pid, vid) {
    if (!/^[1-9]\d{0,19}$/.test(pid) || !/^[1-9]\d{0,19}$/.test(vid)) return Promise.resolve(null);
    if (storageGet(AUS_KEY) === 'off') return Promise.resolve(null);
    var key = CACHE_PREFIX + pid + ':' + vid;
    var alt = gemerkt(key);
    if (alt !== undefined) return Promise.resolve(alt);
    var geteilt = geteilterAbruf(pid, vid);
    if (geteilt) {
      return mitFrist(TIMEOUT_MS, function () {
        return geteilt;
      }).then(function (data) {
        if (!data || typeof data !== 'object' || data.zeitlimit || data.fehler) return null;
        var kopie;
        try {
          // Eigene Kopie: der Zubehoerblock haelt dasselbe Objekt.
          kopie = JSON.parse(JSON.stringify(data));
        } catch (e) {
          return null;
        }
        var vorlaeufig = kopie.status === 'retry' || (kopie.reifen && kopie.reifen.status === 'retry');
        if (!vorlaeufig && kopie.v === 1) storageSet(key, JSON.stringify({ t: Date.now(), a: kopie }));
        return kopie;
      });
    }
    var url = ENDPOINT + '?pid=' + encodeURIComponent(pid) + '&vid=' + encodeURIComponent(vid);
    return mitFrist(TIMEOUT_MS, function (signal) {
      var opt = { headers: { Accept: 'application/json' }, credentials: 'same-origin' };
      if (signal) opt.signal = signal;
      return window.fetch(url, opt).then(function (res) {
        if (!res) return null;
        if (res.status === 404) {
          // Route (noch) nicht ausgerollt: fuer diese Sitzung Ruhe.
          storageSet(AUS_KEY, 'off');
          return null;
        }
        if (!res.ok) return null;
        return res.json().then(function (data) {
          var vorlaeufig = !data || typeof data !== 'object' || data.status === 'retry' || (data.reifen && data.reifen.status === 'retry');
          if (!vorlaeufig && data.v === 1) storageSet(key, JSON.stringify({ t: Date.now(), a: data }));
          return data;
        });
      });
    }).then(function (x) {
      return x && (x.zeitlimit || x.fehler) ? null : x;
    });
  }

  /** Adresse des Kartenabrufs: Ziel + section_id + Sortierung (bestehende Filter bleiben). */
  function kartenUrl(ziel, sort) {
    if (!sichereUrl(ziel)) return null;
    var u;
    try {
      u = new URL(ziel, window.location.origin);
    } catch (e) {
      return null;
    }
    if (u.origin !== window.location.origin) return null;
    u.searchParams.set('section_id', KARTEN_SECTION);
    if (SORTS[sort]) u.searchParams.set('sort_by', sort);
    return u.pathname + u.search;
  }

  /**
   * Promise<Element[]|null> — die <li> der Karten (null = Abruf gescheitert). `kartenCache`
   * gehoert dem Element (je Seitenaufruf eins): Hin- und Herschalten fragt nicht erneut,
   * ein Fehlschlag wird nicht gemerkt.
   */
  function ladeKarten(url, kartenCache) {
    if (kartenCache[url]) return kartenCache[url];
    var p = mitFrist(KARTEN_TIMEOUT_MS, function (signal) {
      var opt = { credentials: 'same-origin' };
      if (signal) opt.signal = signal;
      return window.fetch(url, opt).then(function (res) {
        if (!res || !res.ok) return { fehler: true };
        return res.text();
      });
    }).then(function (x) {
      if (typeof x !== 'string') {
        delete kartenCache[url];
        return null;
      }
      var doc = new DOMParser().parseFromString(x, 'text/html');
      var liste = doc.querySelector('[data-ap-kr-liste]');
      if (!liste) return [];
      return Array.prototype.slice.call(liste.children).filter(function (el) {
        return el.tagName === 'LI';
      });
    });
    kartenCache[url] = p;
    return p;
  }

  /** Eingefuegte <script> laufen per DOM nicht — card-product definiert so <ap-card-qty>. */
  function skripteAusfuehren(root) {
    Array.prototype.forEach.call(root.querySelectorAll('script'), function (alt) {
      if (alt.type && alt.type !== 'text/javascript' && alt.type !== 'module') return;
      var neu = document.createElement('script');
      Array.prototype.forEach.call(alt.attributes, function (a) {
        neu.setAttribute(a.name, a.value);
      });
      neu.textContent = alt.textContent;
      alt.parentNode.replaceChild(neu, alt);
    });
  }

  /**
   * fn nach `load` im Leerlauf — spaetestens aber nach NACH_LOAD_SPAETESTENS ms: haelt ein
   * fremdes Teil das load-Ereignis auf (Iframe, Pixel, haengender Abruf; in der Vorschau
   * 29.09.2026 kam es in Playwright nach 90 s nicht), stuende der Block sonst nie.
   */
  var NACH_LOAD_SPAETESTENS = 4000;
  function nachLoad(fn) {
    var gestartet = false;
    var los = function () {
      if (gestartet) return;
      gestartet = true;
      if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(fn, { timeout: 2000 });
      else setTimeout(fn, 200);
    };
    if (document.readyState === 'complete') {
      los();
      return;
    }
    window.addEventListener('load', los, { once: true });
    setTimeout(los, NACH_LOAD_SPAETESTENS);
  }

  /** fn, sobald `ziel` naeher als VORLAUF an den sichtbaren Bereich kommt (ohne IO: sofort). */
  function inDerNaehe(ziel, fn) {
    if (!ziel || typeof window.IntersectionObserver !== 'function') {
      fn();
      return;
    }
    var io = new IntersectionObserver(
      function (eintraege) {
        if (!eintraege.some(function (e) { return e.isIntersecting; })) return;
        io.disconnect();
        fn();
      },
      { rootMargin: VORLAUF },
    );
    io.observe(ziel);
  }

  /* ------------------------------------------------------------ Element */

  class ApKomplettReifen extends HTMLElement {
    connectedCallback() {
      if (this.dataset.apKrBereit) return;
      this.dataset.apKrBereit = 'true';
      // Einen Mikrotakt spaeter: wird das Element beim Parsen (oder per innerHTML) schon beim
      // Oeffnen des Tags verbunden, stehen seine Kinder (Texte, Muster) noch nicht im Baum.
      var self = this;
      Promise.resolve().then(function () {
        self.einrichten();
      });
    }

    einrichten() {
      this.texte = this.leseJson('[data-ap-kr-texte]') || {};
      this.sprache = String(this.texte.sprache || document.documentElement.lang || 'de').slice(0, 2);
      this.muster = this.hasAttribute('data-muster');
      this.max = Math.max(3, Math.min(8, parseInt(this.dataset.max, 10) || 6));
      this.sort = SORTS[this.dataset.sort] ? this.dataset.sort : 'price-ascending';
      this.heute = new Date().getFullYear();
      this.saison = 'alle';
      this.auswahl = null;
      this.lauf = 0;
      this.kartenCache = {};
      var self = this;
      if (this.muster) {
        // Muster: sofort, ohne Proxy (Beispieldaten nach dem Vertrag).
        this.start(Promise.resolve(this.leseJson('[data-ap-kr-muster]')));
        return;
      }
      nachLoad(function () {
        inDerNaehe(self.closest('.ap-wheel-link') || self.parentElement, function () {
          // Seite schon verlassen (Element entfernt): nicht mehr fragen.
          if (!self.isConnected) return;
          self.start(ladeFelgenSet(String(self.dataset.pid || ''), String(self.dataset.vid || '')));
        });
      });
    }

    leseJson(sel) {
      var el = this.querySelector(sel);
      if (!el) return null;
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        return null;
      }
    }

    /** Promise<boolean> — true, wenn der Block jetzt steht. */
    start(antwortPromise) {
      var self = this;
      return Promise.resolve(antwortPromise).then(function (roh) {
        var daten = leseAntwort(roh, self.heute);
        if (!daten) return false;
        self.daten = daten;
        self.musterZiele = self.muster && roh && roh._muster && roh._muster.saisonZiele ? roh._muster.saisonZiele : null;
        self.aufbauen();
        if (!self.muster) self.linkUmstellen();
        return true;
      });
    }

    /** Die PKW-Linkkarte auf die Umleitung der App (PKW+SUV) stellen — Begruendung im Kopf. */
    linkUmstellen() {
      var d = this.daten;
      var wurzel = this.closest('.ap-wheel-link') || this.parentNode;
      var link = wurzel && wurzel.querySelector ? wurzel.querySelector('a[data-ap-kr-link]') : null;
      if (!link || d.zoll == null || d.j == null) return;
      var ds = String(d.zoll);
      var js = String(d.j);
      if (!/^\d{1,2}$/.test(ds) || !/^\d{1,2}(?:\.\d{1,2})?$/.test(js)) return;
      link.setAttribute('href', UMLEITUNG + '?d=' + ds + '&j=' + js + '&klasse=pkw');
      var label = link.getAttribute('data-ap-kr-link-label');
      var span = link.querySelector('.ap-wheel-link__card-label');
      if (label && span) span.textContent = label;
      link.setAttribute('data-ap-kr-link', 'umgestellt');
    }

    aufbauen() {
      var d = this.daten;
      var t = this.texte;
      var self = this;
      // Titel „Reifen für 6,0J × 14″" — Maulweite mit Nachkommastelle wie der Zubehoerblock direkt
      // darueber (Pruefrunde 1: vorher „6J × 14″" unter „6,0J × 14″"); Rechnung window.apMass
      // (assets/ap-mass.js, JS-Zwilling von snippets/ap-felgenbreite).
      var titel = this.querySelector('[data-ap-kr-titel]');
      if (titel && d.j != null && d.zoll != null && t.titel) {
        var mass = window.apMass;
        var jText = mass && typeof mass.breite === 'function' ? mass.breite(d.j, { sep: this.sprache === 'de' ? ',' : '.' }) : dezimal(/^\d+$/.test(String(d.j)) ? d.j + '.0' : d.j, this.sprache);
        titel.textContent = fuelle(t.titel, { j: jText, d: dezimal(d.zoll, this.sprache) });
      }
      // Groessen-Chips: echte Radios, vorgewaehlt die Groesse mit dem groessten Angebot.
      var chips = this.querySelector('[data-ap-kr-groessen]');
      var start = 0;
      d.groessen.forEach(function (g, i) {
        if (g.anzahl.alle > d.groessen[start].anzahl.alle) start = i;
      });
      var name = 'ap-kr-groesse-' + Math.random().toString(36).slice(2, 8);
      this.chipLabels = [];
      d.groessen.forEach(function (g, i) {
        var label = document.createElement('label');
        label.className = 'ap-chip ap-chip--select ap-kr__chip';
        var input = document.createElement('input');
        input.type = 'radio';
        input.name = name;
        input.value = String(i);
        if (i === start) input.checked = true;
        input.addEventListener('change', function () {
          if (input.checked) self.waehleGroesse(i);
        });
        var text = document.createElement('span');
        text.className = 'ap-kr__chip-text';
        var groesse = document.createElement('span');
        groesse.className = 'ap-kr__chip-groesse';
        groesse.textContent = self.groesseText(g);
        text.appendChild(groesse);
        var preis = self.chipPreis(g);
        if (preis) {
          var meta = document.createElement('span');
          meta.className = 'ap-chip__meta ap-kr__chip-preis';
          meta.textContent = preis;
          text.appendChild(meta);
        }
        label.appendChild(input);
        label.appendChild(text);
        if (chips) chips.appendChild(label);
        self.chipLabels.push(label);
      });
      // Saison-Umschalter
      Array.prototype.forEach.call(this.querySelectorAll('.ap-kr__saison input[type="radio"]'), function (input) {
        if (SAISONS.indexOf(input.value) < 0) return;
        input.addEventListener('change', function () {
          if (input.checked) self.waehleSaison(input.value);
        });
      });
      // Groessen ausserhalb der J-Spanne (nur Hinweis)
      var andere = this.querySelector('[data-ap-kr-andere]');
      if (andere && d.andere.length && d.j != null && t.andere) {
        var liste = d.andere
          .map(function (k) {
            return k + ' R' + dezimal(d.zoll, self.sprache);
          })
          .join(', ');
        andere.textContent = fuelle(t.andere, { j: dezimal(d.j, this.sprache), liste: liste });
        andere.hidden = false;
      }
      // Kartenreihe
      this.liste = this.querySelector('[data-ap-kr-ziel]');
      this.zurueck = this.querySelector('[data-ap-kr-zurueck]');
      this.weiter = this.querySelector('[data-ap-kr-weiter]');
      if (this.zurueck) this.zurueck.addEventListener('click', function () { self.blaettern(-1); });
      if (this.weiter) this.weiter.addEventListener('click', function () { self.blaettern(1); });
      if (this.liste) this.liste.addEventListener('scroll', function () { self.pfeile(); }, { passive: true });
      if (typeof window.ResizeObserver === 'function' && this.liste) {
        new ResizeObserver(function () { self.pfeile(); }).observe(this.liste);
      }
      this.hidden = false;
      // Der Zubehoerblock („Das brauchen Sie zur Felge") wird dann eine Uebersichtszeile mit Sprung
      // hierher (Pruefrunde 1: zwei Reifenauswahlen hintereinander) — assets/ap-felgen-set.js kompakt().
      this.setAttribute('data-ap-kr-bereit', '');
      document.dispatchEvent(new CustomEvent('ap-kr:bereit'));
      this.waehleGroesse(start);
      if (this.chipLabels[start]) this.chipInsBild(this.chipLabels[start]);
    }

    /** Die gewaehlte Groesse in der Wischzeile sichtbar machen — ohne die SEITE zu rollen.
     *  Pruefrunde 2 Phase B (minor, 360 px): lief die Zeile beim Aufruf noch NICHT ueber — das Stylesheet
     *  section-komplett-reifen.css laedt asynchron (sections/wheel-tyre-link.liquid), die Chips werden erst
     *  danach gross —, brach der Aufruf ab: 185/55 R14 (Index 2) blieb zu 38 % sichtbar, scrollLeft 0, waehrend
     *  darunter „Ab-Preise für 185/55 R14" stand. Jetzt wartet EIN ResizeObserver (Zeile + Chip) auf den ersten
     *  Ueberlauf, zieht die DANN gewaehlte Groesse nach und trennt sich; eine eigene Wischbewegung beendet das
     *  Warten (nie gegen die Hand rollen). */
    chipInsBild(label) {
      var zeile = label.parentNode;
      if (!zeile) return;
      if (!(zeile.scrollWidth > zeile.clientWidth)) {
        this.chipSpaeter(zeile, label);
        return;
      }
      var links = label.offsetLeft - zeile.offsetLeft;
      if (links + label.offsetWidth > zeile.scrollLeft + zeile.clientWidth || links < zeile.scrollLeft) {
        zeile.scrollLeft = Math.max(0, links - 16);
      }
    }

    chipSpaeter(zeile, label) {
      if (this.chipWache || typeof window.ResizeObserver !== 'function') return;
      var self = this;
      var hand = function () {
        weg();
      };
      var weg = function () {
        if (!self.chipWache) return;
        self.chipWache.disconnect();
        self.chipWache = null;
        zeile.removeEventListener('pointerdown', hand);
        zeile.removeEventListener('wheel', hand);
      };
      this.chipWache = new ResizeObserver(function () {
        // schon getrennt (Wischbewegung) — eine bereits eingereihte Meldung rollt nicht mehr
        if (!self.chipWache) return;
        if (!(zeile.scrollWidth > zeile.clientWidth)) return;
        weg();
        // die Groesse, die JETZT gewaehlt ist (der Radio steckt im Chip-Label)
        var gewaehlt = zeile.querySelector('input:checked');
        var ziel = gewaehlt ? gewaehlt.parentNode : label;
        if (ziel && ziel.parentNode === zeile) self.chipInsBild(ziel);
      });
      this.chipWache.observe(zeile);
      this.chipWache.observe(label);
      zeile.addEventListener('pointerdown', hand, { passive: true });
      zeile.addEventListener('wheel', hand, { passive: true });
    }

    groesseText(g) {
      return g.breite + '/' + g.querschnitt + ' R' + dezimal(g.zoll, this.sprache);
    }

    /** „ab 27,99 €" — das guenstigste der beiden Angebote (die Box nennt beide getrennt). */
    chipPreis(g) {
      var p = g.neu != null && g.dot != null ? Math.min(g.neu, g.dot) : g.neu != null ? g.neu : g.dot;
      return p != null && this.texte.ab ? fuelle(this.texte.ab, { preis: geld(p) }) : '';
    }

    waehleGroesse(i) {
      this.auswahl = this.daten.groessen[i];
      var g = this.auswahl;
      // Saison mit 0 Reifen fuer diese Groesse: zurueck auf „Alle".
      if (this.saison !== 'alle' && !(g.anzahl[this.saison] > 0)) this.saison = 'alle';
      this.zeigeSaisons();
      this.zeigePreise();
      this.zeigeKarten();
    }

    waehleSaison(s) {
      if (SAISONS.indexOf(s) < 0) return;
      this.saison = s;
      this.zeigeSaisons();
      this.zeigeKarten();
    }

    zeigeSaisons() {
      var g = this.auswahl;
      var self = this;
      var zahlFormat = this.sprache === 'de' ? 'de-DE' : 'en-GB';
      SAISONS.forEach(function (s) {
        var anzahl = self.querySelector('[data-ap-kr-anzahl="' + s + '"]');
        if (anzahl) anzahl.textContent = fuelle(self.texte.anzahl, { n: g.anzahl[s].toLocaleString(zahlFormat) });
        var input = self.querySelector('.ap-kr__saison--' + s + ' input');
        if (!input) return;
        var leer = s !== 'alle' && !(g.anzahl[s] > 0);
        input.disabled = leer;
        input.closest('label').setAttribute('aria-disabled', leer ? 'true' : 'false');
        input.checked = s === self.saison;
      });
      var wf = this.querySelector('[data-ap-kr-winterfest]');
      if (wf) wf.hidden = !(this.daten.nichtWinterfest && (this.saison === 'winter' || this.saison === 'ganzjahr'));
    }

    zeigePreise() {
      var g = this.auswahl;
      var t = this.texte;
      var box = this.querySelector('[data-ap-kr-preise]');
      if (!box) return;
      var titel = box.querySelector('[data-ap-kr-preise-titel]');
      if (titel) titel.textContent = fuelle(t.preiseTitel, { groesse: this.groesseText(g) });
      var neu = box.querySelector('[data-ap-kr-preis="neu"]');
      var dot = box.querySelector('[data-ap-kr-preis="dot"]');
      if (neu) {
        neu.hidden = g.neu == null;
        if (g.neu != null) neu.querySelector('[data-ap-kr-betrag]').textContent = fuelle(t.ab, { preis: geld(g.neu) });
      }
      if (dot) {
        dot.hidden = g.dot == null;
        if (g.dot != null) {
          dot.querySelector('[data-ap-kr-dot-label]').textContent = dotBeschriftung(g.dotJahr, this.heute, t);
          dot.querySelector('[data-ap-kr-betrag]').textContent = fuelle(t.ab, { preis: geld(g.dot) });
          dot.setAttribute('data-ap-kr-stufe', altersstufe(g.dotJahr, this.heute));
        }
      }
      box.hidden = g.neu == null && g.dot == null;
    }

    /** Ziel der aktuellen Auswahl: Promise<string|null>. */
    ziel() {
      var g = this.auswahl;
      var s = this.saison;
      if (s === 'alle') return Promise.resolve(g.ziel);
      if (this.muster) {
        var z = this.musterZiele && this.musterZiele[g.key] ? this.musterZiele[g.key][s] : null;
        return Promise.resolve(sichereUrl(z));
      }
      if (typeof window.apSizeTarget !== 'function') return Promise.resolve(null);
      return Promise.resolve(
        window.apSizeTarget({ kind: 'tyre', scope: 'felge', w: g.breite, a: g.querschnitt, r: g.zoll, season: SAISON_WERT[s] }),
      ).then(sichereUrl, function () {
        return null;
      });
    }

    zeigeKarten() {
      var self = this;
      var lauf = ++this.lauf;
      var g = this.auswahl;
      var s = this.saison;
      var shell = this.querySelector('[data-ap-kr-karten]');
      if (!shell || !this.liste) return;
      var alleZeile = this.querySelector('[data-ap-kr-alle-zeile]');
      var alle = this.querySelector('[data-ap-kr-alle]');
      var alleText = this.querySelector('[data-ap-kr-alle-text]');
      var leer = this.querySelector('[data-ap-kr-leer]');
      var kartentitel = this.querySelector('[data-ap-kr-kartentitel]');
      shell.hidden = false;
      if (leer) leer.hidden = true;
      // Ueberschrift der Kartenreihe: „Sommerreifen in 175/65 R14" (Auswahl in Worten).
      if (kartentitel) kartentitel.textContent = fuelle(this.texte[KARTEN_TEXT[s]], { groesse: this.groesseText(g) });
      this.liste.hidden = false;
      this.liste.setAttribute('aria-busy', 'true');
      this.platzhalter();
      this.ziel().then(function (ziel) {
        if (lauf !== self.lauf) return;
        var groesse = self.groesseText(g);
        if (alle && alleZeile) {
          if (ziel) {
            alle = alsTag(alle, 'a');
            alle.setAttribute('href', ziel);
            if (alleText) alleText.textContent = fuelle(self.texte[ALLE_TEXT[s]], { groesse: groesse });
            alleZeile.hidden = false;
          } else {
            // Ohne Ziel kein Link: zurueck zum <span> (Q-01), die Zeile verschwindet.
            alle = alsTag(alle, 'span');
            alleZeile.hidden = true;
          }
        }
        var url = ziel ? kartenUrl(ziel, self.sort) : null;
        if (!url) {
          // Kein sicheres Ziel: keine Karten und kein Link — Groesse, Anzahl und Preise bleiben.
          self.kartenWeg(shell);
          return;
        }
        if (!self.isConnected) return;
        ladeKarten(url, self.kartenCache).then(function (eintraege) {
          if (lauf !== self.lauf) return;
          if (eintraege === null) {
            // Abruf gescheitert: keine Karten, kein Fehlertext — der Link bleibt.
            self.liste.textContent = '';
            self.liste.hidden = true;
            self.liste.setAttribute('aria-busy', 'false');
            self.pfeile();
            return;
          }
          self.kartenEnde(eintraege, lauf);
        });
      });
    }

    /** Ohne Ziel verschwindet die ganze Kartenreihe (auch der Link). */
    kartenWeg(shell) {
      this.liste.textContent = '';
      this.liste.setAttribute('aria-busy', 'false');
      shell.hidden = true;
      this.status('');
      this.pfeile();
    }

    kartenEnde(eintraege, lauf) {
      if (lauf !== this.lauf) return;
      var liste = this.liste;
      var leer = this.querySelector('[data-ap-kr-leer]');
      liste.textContent = '';
      var zahl = Math.min(this.max, eintraege.length);
      for (var i = 0; i < zahl; i++) liste.appendChild(document.importNode(eintraege[i], true));
      skripteAusfuehren(liste);
      liste.scrollLeft = 0;
      liste.hidden = zahl === 0;
      if (leer) leer.hidden = zahl > 0;
      liste.setAttribute('aria-busy', 'false');
      this.status(zahl > 0 ? fuelle(this.texte.status, { n: zahl, groesse: this.groesseText(this.auswahl) }) : '');
      this.pfeile();
      if (this.muster) this.musterPreiseAngleichen();
    }

    /* MUSTER (nur Vorschau, Pruefrunde 2 Phase B, minor): die Ab-Preise der Beispielantwort lagen ueber den
     * ECHTEN Karten darunter — „185/55 R14 ab 49,99 €" ueber Karten zu 42,99–43,99 € (live waere das ein
     * UWG-Risiko; dort gilt die App-Antwort, Probe nach dem Promote). Im Muster senkt die guenstigste
     * GELADENE Karte jeder Art den Ab-Preis ihrer Zeile (nie hoeher): ohne DOT -> „Fabrikneu (laut Lieferant
     * …)", mit lesbarem DOT-Jahr -> die DOT-Zeile samt Jahr der Karte. Die Karten tragen Preis, Art und Jahr
     * nur im Muster (sections/ap-komplett-reifen.liquid). */
    musterPreiseAngleichen() {
      var g = this.auswahl;
      if (!g || !this.liste) return;
      var neu = null;
      var dot = null;
      var dotJahr = null;
      Array.prototype.forEach.call(this.liste.querySelectorAll('[data-ap-kr-cent]'), function (li) {
        var cent = parseInt(li.getAttribute('data-ap-kr-cent'), 10);
        if (!(cent > 0)) return;
        var euro = cent / 100;
        var art = li.getAttribute('data-ap-kr-art');
        var jahr = parseInt(li.getAttribute('data-ap-kr-jahr'), 10);
        if (art === 'ohne_dot' && (neu === null || euro < neu)) neu = euro;
        if (art === 'dot' && jahr > 0 && (dot === null || euro < dot)) {
          dot = euro;
          dotJahr = jahr;
        }
      });
      var anders = false;
      if (neu !== null && g.neu != null && neu < g.neu) {
        g.neu = neu;
        anders = true;
      }
      if (dot !== null && g.dot != null && dot < g.dot) {
        g.dot = dot;
        g.dotJahr = dotJahr;
        anders = true;
      }
      if (!anders) return;
      this.zeigePreise();
      var i = this.daten.groessen.indexOf(g);
      var chip = i > -1 && this.chipLabels ? this.chipLabels[i] : null;
      var preis = chip ? chip.querySelector('.ap-kr__chip-preis') : null;
      if (preis) preis.textContent = this.chipPreis(g);
    }

    status(text) {
      var el = this.querySelector('[data-ap-kr-status]');
      if (el) el.textContent = text || '';
    }

    /** Platzhalterkarten in Endhoehe, solange geladen wird (kein Springen). */
    platzhalter() {
      var liste = this.liste;
      if (!liste || liste.querySelector('.ap-kr__eintrag--platzhalter')) return;
      liste.textContent = '';
      for (var i = 0; i < Math.min(4, this.max); i++) {
        var li = document.createElement('li');
        li.className = 'ap-kr__eintrag ap-kr__eintrag--platzhalter';
        li.setAttribute('aria-hidden', 'true');
        liste.appendChild(li);
      }
      this.status(this.texte.laden || '');
    }

    blaettern(richtung) {
      if (!this.liste) return;
      var weite = Math.max(200, this.liste.clientWidth * 0.8);
      if (typeof this.liste.scrollBy === 'function') this.liste.scrollBy({ left: richtung * weite, behavior: 'smooth' });
      else this.liste.scrollLeft += richtung * weite;
    }

    pfeile() {
      if (!this.liste || !this.zurueck || !this.weiter) return;
      var l = this.liste;
      var maus = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)').matches : false;
      var ueberlauf = !l.hidden && l.scrollWidth > l.clientWidth + 2;
      var zeigen = ueberlauf && maus;
      this.zurueck.hidden = !zeigen;
      this.weiter.hidden = !zeigen;
      l.setAttribute('data-ap-rand', !ueberlauf ? 'keiner' : l.scrollLeft <= 2 ? 'anfang' : l.scrollLeft + l.clientWidth >= l.scrollWidth - 2 ? 'ende' : 'mitte');
      if (!zeigen) return;
      this.zurueck.disabled = l.scrollLeft <= 2;
      this.weiter.disabled = l.scrollLeft + l.clientWidth >= l.scrollWidth - 2;
    }
  }

  // Fuer die Proben (tests/komplett-reifen.test.js) — keine oeffentliche Schnittstelle.
  ApKomplettReifen.intern = {
    leseAntwort: leseAntwort,
    altersstufe: altersstufe,
    dotBeschriftung: dotBeschriftung,
    jahrAus: jahrAus,
    kartenUrl: kartenUrl,
    ZIEL_RE: ZIEL_RE,
  };

  window.customElements.define('ap-komplett-reifen', ApKomplettReifen);
})();
